import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fit-blue",
  "use": "fit-blue-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"fit-blue\">\n  <rect width=\"30\" height=\"30\" fill=\"#009dff\" />\n  <path d=\"M15.556,14h-14A1.557,1.557,0,0,1,0,12.444V1.555A1.557,1.557,0,0,1,1.555,0h14a1.557,1.557,0,0,1,1.555,1.555V12.444A1.557,1.557,0,0,1,15.556,14Zm-14-12.452v10.9h14V1.548ZM14,10.889H10.111V9.333h2.333V7H14v3.888ZM4.666,7H3.111V3.111H7V4.667H4.667V7Z\" transform=\"translate(6 8)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol